module.exports = __webpack_public_path__ + "static/media/faq-video-en-1080p.df8a34a4.mp4";